import React from 'react';
import "./style.css";
import AllChairsItem from '../all-chairs-item/index';
import { generateExcel } from './excel';
import LoadingComponent from '../../../../../../../../components/loading/index';
import diagnostics from '../../../../../../../../services/diagnostics/index';

export default class AllChairs extends React.Component {
    state = {
        chair1: [],
        chair2: [],
        chair3: [],
        chair4: [],
        appointments: [],
        diagnostics: [],
        loading: true
    }

    componentDidMount() {
        diagnostics.find({}, (err, diag) => {
            this.setState({loading: false, diagnostics: diag})
        })
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let timeToNumber = (time) => {
            let numbers = time.split(":");
            return 1*numbers[0] + numbers[1]/100;
        }

        let appointments = nextProps.appointments.sort((a,b) => {
            let na = timeToNumber(a.time), nb = timeToNumber(b.time);
            return na-nb
        })
        let chair1 = appointments.filter(appointment => appointment.chair == 1)
        let chair2 = appointments.filter(appointment => appointment.chair == 2)
        let chair3 = appointments.filter(appointment => appointment.chair == 3)
        let chair4 = appointments.filter(appointment => appointment.chair == 4)

        return {
            chair1: chair1,
            chair2: chair2,
            chair3: chair3,
            chair4: chair4,
            appointments: nextProps.appointment
        }
    }

    generateExcel = () => {
        generateExcel(this.state.chair1, this.state.chair2, this.state.chair3, this.state.chair4, this.state.diagnostics);
    }

    render() {
        if(this.state.loading)
            return <LoadingComponent />

        return (
            <div className="AllChairs">
                <div className="columns row">
                    <div className="column is-half">
                        <AllChairsItem {...this.props} appointments={this.state.chair1} chair={1} />
                    </div>
                    <div className="column is-half">
                        <AllChairsItem {...this.props} appointments={this.state.chair2}  chair={2} />
                    </div>
                </div>

                <div className="columns row">
                    <div className="column is-half">
                        <AllChairsItem {...this.props} appointments={this.state.chair3} chair={3} />
                    </div>
                    <div className="column is-half">
                        <AllChairsItem {...this.props} appointments={this.state.chair4} chair={4} />
                    </div>
                </div>
                <button onClick={this.generateExcel} className="floating-export-button">
                    <i className="fas fa-file-excel"></i>
                </button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/home/scenes/pick-day/components/all-chairs/index.js